module.exports = __webpack_public_path__ + "static/media/refresh-live-data.a07a989d.svg";